<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre8">
<span href="#/Text/Section0012" id="id-7275890058005232166" title="Link target outside of Sample">
<img alt="Robert Louis Stevenson" class="calibre9" id="id-5607004571857469723" src="Images/img0002.jpg" title="Robert Louis Stevenson"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?2af43584